<script lang="ts">
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import Button from "../Button.svelte";
	import cake from "../../../../core/assets/icons/cake.svg?raw";
	import check from "../../../../core/assets/icons/check.svg?raw";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import Form from "../Form/Form.svelte";
	import type { VoucherProduct } from "../../../../core/schema/VoucherProduct.js";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import voucherImage from "../../../../core/assets/voucher.jpg";
	import { getVoucherPath } from "../../../../core/schema/paths/getVoucherPath.js";
	import { reportAddedVoucherToCart } from "../../UniversalAnalytics.js";
	import { animateCartCount } from "../../utils/animateCartCount.js";
	import { getCartStore } from "../../contexts/cartStoreContextKey.js";

	export let voucher: VoucherProduct;

	const cartStore = getCartStore();
	const { TENANT_LOCALE } = getGlobalSettings();

	$: isInCart = $cartStore.value.order.vouchers.some(
		({ orderVoucherProduct }) => orderVoucherProduct.id === voucher.id,
	);

	$: price = voucher.value;

	async function putItemToCart(_event: SubmitEvent): Promise<void> {
		const response = await cartStore.addVoucher(voucher);
		reportAddedVoucherToCart(response.item, TENANT_LOCALE);
		animateCartCount();
	}

	$: linkToProduct = `/${getVoucherPath(TENANT_LOCALE, voucher)}`;
</script>

<div
	class="flex h-fit w-full flex-col rounded-[1.375rem] border border-transparent transition-all duration-300 min-[430px]:w-[initial] min-[430px]:basis-[calc(50%-0.5rem)] sm:basis-[calc(50%-0.25rem)] sm:p-4 sm:hover:border-gray-300 md:basis-[calc(50%-0.75rem)] lg:basis-[calc((100%-(2*.75rem))/3)] xl:basis-[calc((100%-(2*1.5rem))/3)] xl:p-6"
>
	<a
		href={linkToProduct}
		class="group relative block aspect-square h-auto w-full overflow-hidden rounded-lg min-[430px]:min-h-[11.9375rem] min-[430px]:min-w-[11.9375rem]"
	>
		<div class="bg-secondary-40 group flex h-full w-full items-center justify-center rounded-lg">
			<StaticPicture
				alt="Voucher"
				image={voucherImage}
				class="opacity-80 transition-all duration-300 group-hover:opacity-100 "
				width={400}
				height={400}
			/>
		</div>
	</a>
	<Form
		onsubmit={putItemToCart}
		class="mt-4 grid h-[9.25rem] grid-rows-[repeat(3,1fr)] gap-2 min-[430px]:h-[11.5rem] min-[430px]:grid-rows-[1fr,1fr,2.25rem] md:h-[9.25rem] md:grid-rows-[repeat(3,1fr)] lg:h-[12rem] lg:grid-rows-[1fr,1fr,2.25rem] xl:h-[9.25rem] xl:grid-rows-[repeat(3,1fr)]"
	>
		<a
			class="text-md md:text-md line-clamp-2 h-14 font-semibold leading-7 min-[430px]:text-base min-[430px]:leading-[1.3] md:leading-[1.5]"
			href={linkToProduct}
		>
			{voucher.name[TENANT_LOCALE]}
		</a>
		<div
			class="mb-2 flex justify-end min-[430px]:mb-0 min-[430px]:flex-col md:mb-2 md:flex-row lg:mb-0 lg:flex-col xl:mb-2 xl:flex-row"
		>
			<span class="text-md font-semibold leading-7 min-[430px]:mb-1 min-[430px]:mt-3 md:my-0 lg:mb-2 lg:mt-3 xl:my-0">
				{nbspify(formatPrice(price, TENANT_LOCALE, false))}
			</span>
		</div>
		<div class="flex items-end justify-end gap-4">
			<Button
				type="submit"
				variant="primary"
				class="whitespace-nowrap text-base font-semibold leading-5 min-[430px]:w-full min-[430px]:justify-center min-[430px]:text-xs md:w-fit md:justify-start md:text-base lg:w-full lg:justify-center xl:w-fit xl:justify-start {isInCart
					? '!bg-tertiary !border-tertiary hover:!bg-tertiary focus:!bg-tertiary active:!bg-tertiary hover:!border-tertiary focus:!border-tertiary active:!border-tertiary pointer-events-none !text-white hover:!text-white focus:!text-white active:!text-white'
					: ''}"
				iconClass="w-[0.875rem]"
				icon={isInCart ? check : cake}
			>
				<div class="together">
					<div class:opacity-0={isInCart}>Do krabice</div>
					<div class:opacity-0={!isInCart}>V krabici</div>
				</div>
			</Button>
		</div>
	</Form>
</div>

<style lang="postcss">
	.together {
		display: grid;
		grid-template-areas: "single";

		& > * {
			grid-area: single;
		}
	}
</style>
